export const FEATURES_TOGGLES = {
    IsVKAuthEnable: 'IsVKAuthEnable',
    IsYandexAuthEnable: 'IsYandexAuthEnable',
} as const;

export const FEATURES_DEFAULT = Object.fromEntries(Object.entries(FEATURES_TOGGLES).map((item) => [item, true]));
